import { render, staticRenderFns } from "./SalesmanDetails-company.vue?vue&type=template&id=6ad8fa40"
import script from "./SalesmanDetails-company.vue?vue&type=script&lang=js"
export * from "./SalesmanDetails-company.vue?vue&type=script&lang=js"
import style0 from "./SalesmanDetails-company.vue?vue&type=style&index=0&id=6ad8fa40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports